let bioData = {
  imagebaseurl: "https://pvbarredo.github.io/",
  name: "Peter Barredo",
  fullName: "Peter Emmanuel Barredo",
  address:
    "#30-A Greenheights Avenue, Greenheights Village Paranaque City Philippines",
  role: "Full Stack Developer",
  telephone: "826-40-95",
  cellphone: "+639772510805",
  email: "pvbarredo@gmail.com"
};
export default bioData;
